import React from 'react';
import PropTypes from 'prop-types';
import utils from "../../utils/utils";
import DATE_FORMAT from "../../components/constants/dateFormat";
import {Link} from "react-router-dom";
import apiCalls from "../../utils/apiCalls";
import classNames from "classnames";
import {injectIntl} from "react-intl";
import MarketplaceAdminBillPdfDocument from "../../marketplace/marketplaceAdminBillPdfDocument";
import {pdf} from "@react-pdf/renderer";
import { saveAs } from 'file-saver';
import {removeBillFromList} from "./billsActions";
import {connect} from "react-redux";

const AdminBillRow = ({bill, showDeadline, removeBillFromList, intl}) => {
  const dateCreated = utils.getDateFromString(bill.dateCreated).format(DATE_FORMAT.displayWithTime);
  const deadline = utils.getDateFromString(bill.deadline);
  const formattedDeadline = deadline? deadline.format(DATE_FORMAT.display): '-';

  const from = bill.from? bill.from.className === 'CompanyBillDetails'? bill.from.companyName: bill.from.fullName: '-';
  const to = bill.to? bill.to.className === 'CompanyBillDetails'? bill.to.companyName: bill.to.fullName: '-';

  function setBillStatus() {
    const newBill = Object.assign({}, bill);
    newBill.status = 'PAID';
    return apiCalls.editBill({bill: newBill})
      .then((result) => {
        removeBillFromList(bill);
      })
      .catch((error) => {
        window.alert(utils.getErrorMessageFromResponse(error, true));
        window.scrollTo(0, 0);
      });
  }

  const now = utils.getNowDate();
  const inThreeDays = utils.getNowDate();
  inThreeDays.add(3, "days");

  const deadlineClasses = classNames({
    "text-warning": bill.status !== 'PAID' && deadline && deadline.isBefore(inThreeDays),
    "text-danger": bill.status !== 'PAID' && deadline && deadline.isBefore(now),
  });

  function deleteBill() {
    const confirmMessage = intl.formatMessage({id: 'bill.view.delete.confirm'});

    if (window.confirm(confirmMessage)) {
      apiCalls.deleteBill(bill.id)
        .then(() => {
          removeBillFromList(bill);
        }).catch((errors) => {
        window.alert(utils.getErrorMessageFromResponse(errors, true));
      });
    }
  }

  async function download(bill) {
    const pdfCopy = utils.getPdfCopy(intl, bill);

    const doc = <MarketplaceAdminBillPdfDocument bill={bill} copy={pdfCopy}/>;
    const asPdf = pdf(); // {} is important, throws without an argument
    asPdf.updateContainer(doc);
    const blob = await asPdf.toBlob();
    saveAs(blob, `${bill.title}.pdf`);
  }

  return (
    <tr>
      <td>
        {bill.title}
      </td>
      <td>
        {to}
      </td>
      <td>
        {from}
      </td>
      <td>
        {bill.amount}€
      </td>
      <td>
        {bill.status}
      </td>
      {
        showDeadline? (
          <td className={deadlineClasses}>
            {formattedDeadline}
          </td>
        ): ''
      }
      <td>
        {dateCreated}
      </td>
      <td>
        <Link to={`/admin/bill/${bill.id}`} className="link">
          View
        </Link><br/>
        <button className="btn btn-normal-link" onClick={setBillStatus}>Mark PAID</button><br/>
        <button className="btn btn-normal-link" onClick={() => download(bill)}>Download</button><br/>
        <button className="btn btn-normal-link" onClick={deleteBill}>Delete</button><br/>
      </td>
    </tr>
  );
}

AdminBillRow.propTypes = {
  bill: PropTypes.object.isRequired,
  showDeadline: PropTypes.bool,
};

AdminBillRow.defaultProps = {};

function mapStateToProps() {
  return {
  };
}

const mapDispatchToProps = {
  removeBillFromList,
};

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(AdminBillRow));